// assets
import { IconFile, IconTags, IconCategory, IconPlus, IconSpeakerphone, IconUsers, IconLayout, IconTemplate } from '@tabler/icons';

// constant
const icons = {
  IconFile,
  IconPlus,
  IconTags,
  IconCategory,
  IconSpeakerphone,
  IconUsers,
  IconLayout,
  IconTemplate
};

// ==============================|| POSTS MENU ITEMS ||============================== //

const posts = {
  id: 'contentsGroup',
  title: 'Conteúdos',
  type: 'group',
  children: [
    {
      id: 'contents-view',
      title: 'Conteúdos',
      type: 'collapse',
      icon: icons.IconFile,
      children: [
        {
          id: 'contents-view',
          title: 'Conteúdos',
          type: 'item',
          url: 'contents',
          icon: icons.IconFile
        },
        {
          id: 'contents-create',
          title: 'Novo conteúdo',
          type: 'item',
          url: 'contents/add',
          icon: icons.IconPlus
        },
        {
          id: 'tags-view',
          title: 'Palavras-chave',
          type: 'item',
          url: 'contents/tags',
          icon: icons.IconTags
        },
        {
          id: 'categories-view',
          title: 'Áreas de conhecimento',
          type: 'item',
          url: 'contents/categories',
          icon: icons.IconCategory
        },
        {
          id: 'contenttypes-view',
          title: 'Tipos de conteúdo',
          type: 'item',
          url: 'contents/contenttypes',
          icon: icons.IconTemplate
        }
      ]
    },
    {
      id: 'pages-view',
      title: 'Páginas',
      type: 'collapse',
      icon: icons.IconFile,
      children: [
        {
          id: 'pages-view',
          title: 'Páginas',
          type: 'item',
          url: 'pages',
          icon: icons.IconFile
        },
        {
          id: 'pages-create',
          title: 'Nova página',
          type: 'item',
          url: 'pages/add',
          icon: icons.IconPlus
        }
      ]
    },
    {
      id: 'disclosures-view',
      title: 'Divulgações',
      type: 'collapse',
      icon: icons.IconSpeakerphone,
      children: [
        {
          id: 'disclosures-view',
          title: 'Divulgações',
          type: 'item',
          url: 'disclosures',
          icon: icons.IconSpeakerphone
        },
        {
          id: 'disclosures-create',
          title: 'Nova Divulgação',
          type: 'item',
          url: 'disclosures/add',
          icon: icons.IconPlus
        }
      ]
    },
    {
      id: 'partners-view',
      title: 'Parceiros',
      type: 'collapse',
      icon: icons.IconUsers,
      children: [
        {
          id: 'partners-view',
          title: 'Parceiros',
          type: 'item',
          url: 'partners',
          icon: icons.IconUsers
        },
        {
          id: 'partners-create',
          title: 'Novo Parceiro',
          type: 'item',
          url: 'partners/add',
          icon: icons.IconPlus
        }
      ]
    },
    {
      id: 'widgets-view',
      title: 'Widgets',
      type: 'item',
      url: 'widgets',
      icon: icons.IconLayout
    }
  ]
};

export default posts;
